import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { Icon } from '../icon';
import { Mobile } from './mobile';
import { Desktop } from './desktop';
/**
 * `<Logo />` - Компонент, изображающий логотип компании.
 *
 * @example ```jsx
 * <Logo variant="secondary" />
 * ```
 */

export const Logo = /*#__PURE__*/forwardRef(function Logo({
  className = '',
  variant = 'primary',
  ...props
}, ref) {
  const classNames = useMemo(() => clsx(styles.logo, styles[variant], className), [className, variant]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames,
    ...props,
    "data-testid": "logo"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: 48,
    height: 40
  }, /*#__PURE__*/React.createElement(Mobile, null)), /*#__PURE__*/React.createElement(Icon, {
    width: 60,
    height: 40
  }, /*#__PURE__*/React.createElement(Desktop, null)));
});